(() => {
  if (window.earlyAccessSmoothScroll) return;
  window.earlyAccessSmoothScroll = true;

  const selector = 'a[href="#early-access-products"]';
  const duration = 650;
  let frame;
  let restoreScrollBehavior;

  const stopAnimation = () => {
    if (frame) cancelAnimationFrame(frame);
    frame = null;
    restoreScrollBehavior?.();
    restoreScrollBehavior = null;
  };

  document.addEventListener('click', (event) => {
    const link = event.target.closest(selector);
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
      return;
    }

    const target = document.getElementById('early-access-products');
    if (!target) return;

    event.preventDefault();
    stopAnimation();

    const root = document.documentElement;
    const previousScrollBehavior = root.style.getPropertyValue('scroll-behavior');
    const previousScrollPriority = root.style.getPropertyPriority('scroll-behavior');
    root.style.setProperty('scroll-behavior', 'auto', 'important');
    restoreScrollBehavior = () => {
      if (previousScrollBehavior) {
        root.style.setProperty('scroll-behavior', previousScrollBehavior, previousScrollPriority);
      } else {
        root.style.removeProperty('scroll-behavior');
      }
    };

    const start = window.scrollY;
    const scrollMargin = parseFloat(getComputedStyle(target).scrollMarginTop) || 0;
    const destination = Math.max(0, target.getBoundingClientRect().top + start - scrollMargin);
    const distance = destination - start;
    const startedAt = performance.now();

    history.pushState(null, '', link.hash);

    const animate = (now) => {
      const progress = Math.min((now - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      window.scrollTo(0, start + distance * eased);

      if (progress < 1) {
        frame = requestAnimationFrame(animate);
      } else {
        frame = requestAnimationFrame(stopAnimation);
      }
    };

    frame = requestAnimationFrame(animate);
  });
})();
